import {InjectionToken} from '@angular/core';

export interface FeatureFlagConfig {
    url: string;
    cacheTimeout?: number;
    allEnabled?: boolean;
}

export const FEATURE_FLAG_CONFIG = new InjectionToken<FeatureFlagConfig>('featureFlag.config');
